<template>
    <div class="alert-ccb-feature">
        <modal height="auto" width="515px" name="unblock-ip-new-feature-modal" :clickToClose="false">
            <div class="informative-modal flex flex-col" style="padding: 20px;">
                <div class="header">
                    New Feature! Unblock IP after a period
                </div>
                <div class="body" style="color: rgba(0, 0, 0, 0.9);">
                    By default, PPC Shield blocks the IP address for 30 days. If you wish, you may change this period to a number between 1 and 60 in Blocking settings. Using a value of 10, for example, the system will block the IP address from which the fraudulent click originated for 10 days.
                </div>
                <div class="footer flex justify-content-end space-x-2">
                    <button class="btn mr-2" @click="onNotNow">NOT NOW</button>
                    <button class="btn btn-primary" style="color: white" @click="onEnable">BLOCKING SETTINGS</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                canShowAlert: true,
            }
        },
        methods: {
            temporarilyHide(){
                this.$modal.hide('unblock-ip-new-feature-modal');
            },
            onEnable() {
                axios.post('/notification/unblockIpFeatureHide')
                    .then(info => {
                        this.$modal.hide('unblock-ip-new-feature-modal');

                        let a = document.createElement('a');
                        a.href = '/settings';
                        a.click();
                    })
                    .catch(err => console.log('err', err));
            },
            onNotNow() {
                this.$modal.hide('unblock-ip-new-feature-modal');

                axios.post('/notification/unblockIpFeatureHide')
                    .then(info => {

                    })
                    .catch(err => console.log('err', err));
            },
            showAlert(){
                this.$modal.show('unblock-ip-new-feature-modal');
                this.canShowAlert = false;
            }
        },
        mounted() {
            this.showAlert();
            /*const _this = this;
            $('body').click(function (event) {
                if (_this.canShowAlert) {
                    event.stopPropagation();
                    event.preventDefault();
                    _this.showAlert();
                    _this.canShowAlert = false;
                }
            });*/
        }
    }
</script>
